import { render, staticRenderFns } from "./Bblogin.vue?vue&type=template&id=6223fff7&scoped=true"
import script from "./Bblogin.vue?vue&type=script&lang=js"
export * from "./Bblogin.vue?vue&type=script&lang=js"
import style0 from "./Bblogin.vue?vue&type=style&index=0&id=6223fff7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6223fff7",
  null
  
)

export default component.exports